import { render, staticRenderFns } from "./ThirdOnlyLogin.vue?vue&type=template&id=542d41f3&scoped=true"
import script from "./ThirdOnlyLogin.vue?vue&type=script&lang=js"
export * from "./ThirdOnlyLogin.vue?vue&type=script&lang=js"
import style0 from "./ThirdOnlyLogin.vue?vue&type=style&index=0&id=542d41f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d41f3",
  null
  
)

export default component.exports